import React from 'react';
import { Avatar } from '@mui/material';
import clsx from 'clsx';
import { useStyles } from './AppAvatar.styles';
import theme from '../../../styles/theme';

export enum AvatarTypes {
  square = 'square',
  round = 'round',
}

interface IAppAvatarProps {
  src?: string;
  className?: string;
  type?: AvatarTypes;
  size?: number;
  children?: React.ReactNode;
  onClick?: () => void;
}

const AppAvatar: React.FC<IAppAvatarProps> = ({
  src,
  className,
  type = AvatarTypes.round,
  size = 40,
  children,
  onClick = () => {},
}) => {
  const { classes } = useStyles(theme);

  return (
    <div onClick={onClick} className={classes.avatarWrapper}>
      <Avatar
        src={src}
        className={clsx(
          className,
          type === AvatarTypes.square ? classes.squareIcon : classes.roundIcon,
        )}
        style={{ width: `${size}px`, height: `${size}px` }}>
        {children}
      </Avatar>
    </div>
  );
};

export default AppAvatar;
